import React, { useCallback, useEffect, useState } from 'react'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import { Box, Button } from '@mui/material';
import { EquipmentApi, list_equipment_type } from '../../../../api/equipment/equipment.api';
import StateComponents from '../../../../components/state-component/StateComponents';
import { debouncedApiCall } from '../../../../utils/app.utils';
import InputTextMask from '../../../../components/input/inputTextMask';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { equipment_booking_data } from '../../../../api/booking-meeting-room-equipment/booking-meeting-room.api';
import clsx from 'clsx';

type Props = {
    open: boolean;
    handleSubmit: (data: equipment_booking_data[]) => void;
    setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
    id_meeting_room?: number;
    id_room_meeting?: number;

    search_data: any;
    set_search_data: React.Dispatch<React.SetStateAction<any>>;
    set_mode_option: React.Dispatch<React.SetStateAction<'EDIT' | "VIEW" | "">>;
    qty: string;
    set_qty: React.Dispatch<React.SetStateAction<string>>;
    mode_option?: "EDIT" | "VIEW" | "";
}

const ModalEquipment: React.FC<Props> = ({ mode_option, set_mode_option, id_room_meeting, id_meeting_room, handleSubmit, qty, set_qty, open, setShowModal, search_data,
    set_search_data
}: Props) => {
    const base_url = useSelector((state: RootState) => state.api.image_api);
    const [search_equipment, set_search_equipment] = useState<string>("");
    const [equipment_data, set_equipment_data] = useState<any[]>([]);
    const [dataDetail, setDataDetail] = useState<any>(null);
    const [lastFile, setLastFile] = useState<any>(null);


    const handleGetEquipmentData = useCallback(async () => {
        let query: list_equipment_type = {
            page: 1,
            limit: 20
        }
        if (search_equipment) query.keyword = search_equipment
        await EquipmentApi.getAllEquipment(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_equipment_data(response);
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_equipment])

    const handleFindOneEquipment = async (id_equipment: number) => {
        await EquipmentApi.getEquipmentById(id_equipment).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                setLastFile(response?.lastFile);
                setDataDetail(response?.equipment);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleCloseModal = () => {
        setShowModal?.(false);
        clearSearchData();
        setLastFile(null);
        set_mode_option('');
    }
    const clearSearchData = () => {
        set_search_data(null);
        set_search_equipment("");
        set_qty("");
    }


    useEffect(() => {
        if (search_data?.id_meeting_room_equipment && search_data?.id_equipment) {
            handleFindOneEquipment(search_data?.id_equipment)
        }
    }, [search_data])

    useEffect(() => {
        handleGetEquipmentData();
    }, [handleGetEquipmentData])

    return (
        <div>
            {open && (
                <ModalCustom
                    handleClose={handleCloseModal}
                    onClick={() => {
                        id_meeting_room && id_room_meeting && handleSubmit([
                            {
                                id_meeting_room: id_meeting_room,
                                id_equipment: dataDetail?.id_equipment,
                                id_room_meeting: id_room_meeting,
                                meeting_room_equipment_type: "ADD_NEW",
                                qty: qty ? Number(qty) : 1,
                                status: "active",
                            }
                        ])

                        handleCloseModal();
                    }}
                    open
                    title={mode_option === 'EDIT' ? 'แก้ไขอุปกรณ์' : mode_option === 'VIEW' ? 'รายละเอียดอุปกรณ์' : 'เพิ่มอุปกรณ์'}
                    hintSubmitButton={mode_option === 'VIEW'}
                    subTitle='กรุณาเลือกรายการที่ท่านต้องการ'
                    maxWidth='md'
                    disabledSubmitButton={!dataDetail || !qty || (Number(qty) < 1)}
                    scrollBody
                    form={
                        <Box py={2} className="w-full">
                            <Box className='grid grid-cols-12 gap-4'>
                                <span className={clsx("w-full col-span-12", {
                                    'md:col-span-8': mode_option !== 'VIEW'
                                })}>
                                    <StateComponents
                                        disabledAllField={mode_option === 'VIEW'}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    placeholder: "ค้นหา",
                                                    disabled: mode_option === 'EDIT',
                                                    getOptionLabel: (op) => op?.equipment_name || "",
                                                    labelId: "ep",
                                                    onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_equipment }),
                                                    onChange: (_, val) => set_search_data(val ?? null),
                                                    options: equipment_data,
                                                    value: search_data || null
                                                }
                                            }
                                        ]}
                                    />
                                </span>
                                {mode_option !== 'VIEW' && (
                                    <span className='col-span-12 md:col-span-4 flex gap-4'>
                                        <Button onClick={() => {
                                            search_data?.id_equipment && handleFindOneEquipment(search_data?.id_equipment);
                                        }} disabled={!search_data || mode_option === 'EDIT'} fullWidth variant='contained' color='success'>ค้นหา</Button>
                                        <Button onClick={clearSearchData} disabled={!search_data || mode_option === 'EDIT'} fullWidth variant='contained' color='error'>ล้างค่า</Button>
                                    </span>
                                )}
                            </Box>


                            <Box my={2} className="grid grid-cols-12 gap-4">
                                <Box className="col-span-12 md:col-span-6">
                                    <img src={`${base_url}/${lastFile?.file_path}`} alt="a" />
                                </Box>
                                <Box className="col-span-12 md:col-span-6">
                                    <StateComponents
                                        disabledAllField={mode_option === 'VIEW'}
                                        sxContainer={{ py: 2 }}
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: "รหัสอุปกรณ์",
                                                    disabled: true,
                                                    value: dataDetail?.equipment_no || ""
                                                }
                                            },
                                            {
                                                seq: 2,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: "ชื่ออุปกรณ์",
                                                    disabled: true,
                                                    value: dataDetail?.equipment_name || ""
                                                }
                                            },
                                            {
                                                seq: 3,
                                                type: "COMPONENT",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    element: (
                                                        <Box className="grid grid-cols-12 gap-4">
                                                            <span className={
                                                                clsx('col-span-12', {
                                                                    'md:col-span-8': mode_option !== 'VIEW'
                                                                })}>
                                                                <InputTextMask
                                                                    mode='full_number'
                                                                    heading='จำนวน'
                                                                    placeholder='ระบุ'
                                                                    value={qty}
                                                                    onChange={(e) => set_qty(e.target.value)}
                                                                    disabled={!dataDetail || mode_option === 'VIEW'}
                                                                />
                                                            </span>
                                                            {mode_option !== 'VIEW' && (
                                                                <span className='mt-8 flex justify-center items-center gap-4 col-span-12 md:col-span-4'>
                                                                    <Button onClick={() => set_qty((prev) => (Number(prev) - 1).toString())} disabled={!dataDetail || Number(qty) < 2} variant='contained' color="error">-</Button>
                                                                    <Button onClick={() => set_qty((prev) => (Number(prev) + 1).toString())} disabled={!dataDetail} variant='contained' color="success">+</Button>
                                                                </span>
                                                            )}
                                                        </Box>
                                                    )
                                                }
                                            },
                                            {
                                                seq: 4,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: "รหัสอุปกรณ์",
                                                    disabled: true,
                                                    value: dataDetail?.equipment_no || ""
                                                }
                                            },
                                        ]}
                                    />
                                </Box>
                            </Box>
                        </Box >
                    }
                />
            )}
        </div >
    )
}

export default ModalEquipment